<template>
  <div id="news" class="container" >
    <div class="row">
      <div id="doc" class="container-fluid">    
        <div>    
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm"></div>
              <h2 class="title col-sm">新元号ニュース</h2>
              <b-nav-form class="col-sm">
                <b-form-input size="sm" class="mr-sm-2 float-right" placeholder="Search" v-model="searchWordsModel" @keyup.enter="search()"></b-form-input>
                <b-button size="sm" class="my-2 my-sm-0 float-right"  @click="search()" >検索</b-button>
              </b-nav-form>
            </div>
          </div>
          <b-card no-body>
            <b-tabs v-model="tabIndex" small card>
              <b-tab title="全て">
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item)" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="画像">
                <div class="container-fluid">
                    <div class="row ">
                      <template v-for="(item, key) in headlines" >       
                        <div v-if="checkFilter(item) && item['thumbnails']" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                          <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :only-image="true"></news-card> 
                        </div>
                      </template>
                    </div>
                  </div>
              </b-tab>
              <b-tab title="商品" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, '商品')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="経済" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, '経済')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="技術" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, '技術')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="スポーツ" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, 'スポーツ')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="芸能" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, '芸能')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="地域" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, '地域')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab title="令和初" >
                <div class="container-fluid">
                  <div class="row ">
                    <template v-for="(item, key) in headlines" >       
                      <div v-if="checkFilter(item, '令和初')" :key="key" class="card-group col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-1 mx-0" >
                        <news-card  :item="item" v-on:update-current-item="updateCurrentItem" :onlyImage="false"></news-card> 
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>              
            </b-tabs>             
          </b-card>
        </div>
      </div>
      
    </div>


    <b-modal v-if="currentItem" id="display_article" size="lg"  :title="currentItem.title" class="text-left">
      <div class="row">
        <div class="col-3">
        {{currentItem.pubDate | toLocaleTime}}
        </div>
        <div class="col-9">
          URL: <a :href="currentItem.link" target="_blank"><small class=" text-truncate">{{currentItem.link}}</small></a>
        </div>
      </div>
      <div >
        <img class="float-left m-2" v-if="currentItem['thumbnails']" :src="currentItem['thumbnails'][0]" />
        <img class="float-left m-2" v-else src="../assets/reiwa-square.png" width="150"/>
        <div class="p-4">
          <p  v-html="toText(currentItem.description)"/>
        </div>
        <br clear="all" />
        <div v-if="profile.user">
          <p>ソース:<a :href="currentItem.source.url" target="_blank">{{currentItem.source.$t}}</a></p>
          <h5 v-if="currentItem.metadata && currentItem.metadata.keywords">タグ</h5>
          <small v-if="currentItem.metadata && currentItem.metadata.keywords" {{currentItem.metadata.keywords}}</small>
          <h5 v-if="currentItem.words">単語</h5>
           <textarea class="col-12 small" v-if="currentItem.words" rows="5">{{currentItem.words}}</textarea>
          <h5>guid</h5>
          <div class="col-12 text-truncate" style="max-width: ">
          <small >{{currentItem.guid.$t}}</small>
          </div>
          <h5 v-if="currentItem.metadata">メタデータ</h5>
          <textarea class="col-12 small" v-if="currentItem.metadata" rows="5">{{currentItem.metadata}}</textarea>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ok, cancel, hide}">
        <b-button size="md" variant="warning" @click="report()">
          通報
        </b-button>
        <b-button size="md" variant="light" @click="ok()">
          OK
        </b-button>        
      </template>
    </b-modal>
  </div>  
</template>

<script>
import dateformat from 'dateformat';
import jQuery from 'jquery';
import NewsCard from '../components/NewsCard.vue';

export default {
  components: {
    'news-card': NewsCard 
  },
  props: ['articles', 'articlesCurrentCursorDate'],
  data() {    
    return  {
      headlines: {},
      currentItem: null,
      searchWords: '',
      searchWordsModel: null,
      user: this.$profile.user,
      deviceSize: this.mediaQuery(),
      profile: this.$profile
    }
  },
  computed: {
    test() {
      return 'This is test.';
    },
  },
  // watch: {
  //   headlines(items) {
  //     this.headlines = items;
  //     console.log('watch', JSON.stringify(items));
  //     return items;
  //   }
  // },
  filters : {
    toArticleStyle(item) {
        // console.log('toArticleStyle');
        if (item == undefined) return '';
        // console.log(item.title);
        result = `${item.title}: <a href="${item.link}">${item.description}</a>`;
        // console.log('toArticleStyle', result);
        return result;
    },
    toLocaleTime(timeString) {
        timeString = timeString.replace('+0000', '+00:00').replace('+0900', '+09:00').replace(' ','T');
        let pubDate = new Date(timeString).toLocaleString('ja-jp');
        return pubDate;
    }
  },
  methods: {
    stripHtml(html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    },
    toText(description) {
        let text = this.stripHtml(description);
        return text;
    },
    async readNextNews(level = 0) {
      this.log('readNextNews: ', this.currentCursor);
      // 2ヶ月以上前は取得不可
      if (Date.now() - timestamp > 1000 * 3600 * 24 * 60 || level > 10){
        return;
      }
      let counter = 0;
      const docRef = this.$db.collection("cache").doc(`news${this.currentCursor}`);
      const snapshot = await docRef.get();
      const articles = snapshot.get('articles');

      if (articles) {
        articles.forEach((article) => {
        // guidの取得、なければ乱数で割り当て
        let guid = article.guid ? article.guid['$t']: this.currentCursor + '_' + parseInt(100000000 * Math.random());
          // 追加
          this.$set(this.headlines, guid, article);
          console.log(this.currentCursor);
        });
      }
      let date = new Date(this.currentCursor);
      let timestamp = date.getTime() - 3600 * 1000 * 24;
      let newDate = date.setTime(timestamp);
      this.currentCursor =  dateformat(newDate, 'yyyy-mm-dd');

      if (articles == null) {
        // 過去60日分まで
        this.readNextNews(level + 1);         
        return;
      }

      // this.$db.collection("articles").orderBy('pubDate', 'desc').startAfter(this.currentCursor).limit(12).get().then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //         var headline = doc.data();              
      //         this.$set(this.headlines, doc.id, headline);
      //         this.currentCursor = headline.pubDate;
      //     });
      //     // イベント処理
      // });
    },
    mediaQuery() {
      // widthによる分類でメディアクエリーの結果を返す
      if(window.matchMedia('(min-width: 1200px)').matches) {
        // this.log('xl size');
        return 'xl';
      }
      if(window.matchMedia('(min-width: 992px)').matches) {
        // this.log('lg size');
        return 'lg';
      }
      if(window.matchMedia('(min-width: 768px)').matches) {
        // this.log('md size');
        return 'md';
      }
      if(window.matchMedia('(min-width: 576px)').matches) {
        // this.log('sm size');
        return 'sm';
      }
      return 'sm';
    },
    search() {
      this.log('search:'+this.searchWords);
      this.searchWords = this.searchWordsModel;
    },
    checkFilter(item, additionalKeywords = null) {
      const keywordCheck = (keyword) => {
        let flag = false;
        // 何も入力がないときはtrue
        if (keyword == null || keyword == '') return true;
        item.words.forEach( (word) => {
          if (word.indexOf(keyword) >= 0){
            flag = true;
          }
        });
        if ((keyword!= null && item.title.indexOf(keyword) >= 0)){
          flag = true; 
        } else if ((this.searhWords != null && item.description.indexOf(this.searchWords) >= 0)){
          flag = true;
        }
        return flag;
      }

      let searchWords = this.searchWords.trim();
      // 何も入力されていないとき
      if (searchWords == '' && additionalKeywords == null) return true;
      
      let flag = keywordCheck(searchWords);
      if (additionalKeywords != null) {
        // 追加キーワードの処理

        // split
        let keywords = additionalKeywords.trim().split(/[ ,]+/);
        keywords.forEach( (keyword) => {
          if (keyword[0] != '-') {
            let additionalKeywordFlag = keywordCheck(keyword);
            if (searchWords == '') {
              flag = additionalKeywordFlag;
            } else {
              flag = flag && additionalKeywordFlag;
            }
          } else {
            let additionalKeywordFlag = keywordCheck(keyword.substr(1));
            if (searchWords == '') {
              flag = additionalKeywordFlag;
            } else {
              flag = flag && additionalKeywordFlag;
            }
          }
        });

      }
      return flag;
    },
    updateCurrentItem(item) {
      this.log('updateCurrentItem', item);
      this.currentItem = item;
    }
  },
  async mounted() {
    console.log('mounted', this.$route.params);
    // console.log(this.$db);
    this.currentCursor = dateformat(new Date(), 'yyyy-mm-dd');
    // 2日分のデータを読み込む
    await this.readNextNews();
    await this.readNextNews();
    await this.readNextNews();
    await this.readNextNews();
    
    // 画面最下部移動時の処理
    this.$scrollHandler = () => {
      var docHeight = jQuery(document).innerHeight(); 
      var winHeight = jQuery(window).innerHeight();
      var bottom = docHeight - winHeight; 
      // console.log(bottom, jQuery(window).scrollTop());
      if (bottom <= jQuery(window).scrollTop() + 10) {
        //this.log('次へ');
        this.readNextNews();
      }
    }
    this.$resizeHandler = () => {
      this.deviceSize = this.mediaQuery();
    }
    window.addEventListener('scroll', this.$scrollHandler);
    window.addEventListener('resize', this.$resizeHandler);    
  },
  destroyed() {
    window.removeEventListener('resize', this.$resizeHandler);
    window.removeEventListener('scroll', this.$scrollHandler);
    
  }
  
};
</script>

<style>
.title {
  margin: 0.5em;
}
.align-left {
  text-align:left;
}

.description {
  font-size: 0.75rem;
}

#news {
  max-width: 100%
}


</style>